import Speech from 'speak-tts';

export default tts_speak => {
    const speech = new Speech() // will throw an exception if not browser supported
    let speech_init = false;
    // flag because speech.paused() is never fired
    let speech_paused = false;
    const icon = tts_speak.querySelector('i');
    const cssIcon_play = 'icon-play';
    const cssIcon_pause = 'icon-pause';

    if (speech.hasBrowserSupport()) { // returns a boolean
        // console.log('speech synthesis supported');
        speech.init({
            'volume': 1,
            'lang': 'fr-FR',
            'rate': 0.95,
            'pitch': 1,
            // 'voice': 'Thomas',
            'splitSentences': true,
            // 'listeners': {
            //     'onvoiceschanged': (voices) => {
            //         console.log("Event voiceschanged", voices)
            //     }
            // }
        }).then((data) => {
            // The 'data' object contains the list of available voices and the voice synthesis params
            // console.log('Speech is ready, voices are available', data);
            // data.voices.every(voice => {
            //     if (voice.lang === 'fr-FR') {
            //         console.log(voice);
            //         speech.setVoice(voice.name);
            //         return false;
            //     }
            //     return true;
            // });
            setupButton();
        }).catch(e => {
            console.error('An error occured while initializing : ', e);
            removeButton();
        })
    }

    const removeButton = () => {
        tts_speak.remove();
    };

    const setupButton = () => {
        tts_speak.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (!speech_init) {
                speech.speak({
                    text: window.tts_speak_text,
                    queue: false,
                    // listeners: {
                    //     onstart: () => { console.log('Start utterance') },
                    //     onend: () => { console.log('End utterance') },
                    //     onresume: () => { console.log('Resume utterance') },
                    //     onboundary: (event) => { console.log(event.name + ' boundary reached after ' + event.elapsedTime + ' milliseconds.') }
                    // }
                }).then((data) => {
                    // console.log('Success !', data)
                }).catch(e => {
                    // console.error('An error occurred :', e)
                });
                icon.classList.add(cssIcon_pause);
                icon.classList.remove(cssIcon_play);
                speech_paused = false;
                speech_init = true;
            } else if (!speech_paused) {
                speech.pause();
                // flag because speech.paused() is never fired
                speech_paused = true;
                icon.classList.remove(cssIcon_pause);
                icon.classList.add(cssIcon_play);
            } else {
                speech.resume();
                speech_paused = false;
                icon.classList.add(cssIcon_pause);
                icon.classList.remove(cssIcon_play);
            }
        });
    }
};
